import { useState } from 'react'

import { useLightMode } from '@/hooks/useLightMode'
import { HiOutlineInformationCircle } from 'react-icons/hi'

import { Box, Icon, Tooltip } from '@chakra-ui/react'

import {
  Box as DarkBox,
  Tooltip as DarkTooltip,
  tokenPrefix,
  tokenVar,
} from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

interface GridToolTipIProps {
  colorScheme?: ColorScheme
}

export const GridToolTip = ({ colorScheme }: GridToolTipIProps) => {
  const mode = useLightMode()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  if (colorScheme) {
    const tooltipContent = (
      <DarkBox>
        <DarkBox>
          Click on the image to create corners of the area. Four corners would
          be connected to form an area used for tailgate detection or AI
          Operator. You should draw two areas: A red area outside the entrance
          and a green area inside the entrance. You can drag the corners to
          adjust their position. Area edges cannot intersect each other.
        </DarkBox>
        <DarkBox mt='5px'>Tips:</DarkBox>
        <DarkBox>
          ○ When creating tailgating area, try to alight its edges with
          something symmetrical in the image (i.e., cabinet, floor tile, or any
          baseline of measurement)
        </DarkBox>
        <DarkBox>
          ○ Leave a space between the Red and Green, this will reduce false
          positives.
        </DarkBox>
      </DarkBox>
    )

    return (
      <DarkBox
        alignItems='center'
        display='flex'
        onMouseEnter={(event) => setAnchorEl(event.currentTarget)}
        onMouseLeave={() => setAnchorEl(null)}
      >
        <HiOutlineInformationCircle
          color={tokenVar(`colors.${tokenPrefix(colorScheme)}icon.secondary`)}
          size='24px'
        />
        <DarkTooltip
          anchorEl={anchorEl}
          colorScheme={colorScheme}
          label={tooltipContent}
          placement='right'
          variant='description'
        />
      </DarkBox>
    )
  }

  return (
    <Tooltip
      label={
        <Box p='10px'>
          <Box>
            Click on the image to create corners of the area. Four corners would
            be connected to form an area used for tailgate detection or AI
            Operator. You should draw two areas: A red area outside the entrance
            and a green area inside the entrance. You can drag the corners to
            adjust their position. Area edges cannot intersect each other.
          </Box>
          <Box mt='5px'>Tips:</Box>
          <Box>
            ○ When creating tailgating area, try to alight its edges with
            something symmetrical in the image (i.e., cabinet, floor tile, or
            any baseline of measurement)
          </Box>
          <Box>
            ○ Leave a space between the Red and Green, this will reduce false
            positives.
          </Box>
        </Box>
      }
      minW='500px'
      placement='right'
      shouldWrapChildren
    >
      <Icon
        as={HiOutlineInformationCircle}
        boxSize='24px'
        color={`icon.secondary.${mode}`}
      />
    </Tooltip>
  )
}
